import { cleanRawString } from './cleanRawString';

enum IgnoredFacilities {
  LeadingHealthcareFacilities = 'leading healthcare facilities',
}

export const cleanNursegridFacilityParam = (facility: string) => {
  const cleanedFacility = cleanRawString(facility);
  const cleanedFacilityLowerCase = cleanedFacility.toLowerCase();

  // Check if the facility matches any of the ignored facilities
  const ignoredFacilityValues = Object.values(IgnoredFacilities) as string[];
  if (ignoredFacilityValues.includes(cleanedFacilityLowerCase)) {
    return '';
  }

  return cleanedFacility;
};
